// root
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_MINI_LOADING = 'SET_MINI_LOADING';
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const SET_BREAKPOINT = 'SET_BREAKPOINT';
export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_TAG_GOODS = 'SET_TAG_GOODS';
export const RESET_TAG_GOODS = 'RESET_TAG_GOODS';
export const SET_HOT_SEARCH = 'SET_HOT_SEARCH';
export const SET_GOODS_CATEGORY = 'SET_GOODS_CATEGORY';
export const SET_SHOPPING_CART = 'SET_SHOPPING_CART';
export const SET_AD_LIST = 'SET_AD_LIST';
export const SET_BANNER_LIST = 'SET_BANNER_LIST';
export const SET_WEB_CONFIG = 'SET_WEB_CONFIG';
export const SET_USED_COUNTRY = 'SET_USED_COUNTRY';
export const SET_SEARCH_IMAGE_GOODS = 'SET_SEARCH_IMAGE_GOODS';
export const SET_NEWS_LIST = 'SET_NEWS_LIST';
export const SET_LANGUAGE = 'SET_LANGUAGE';

// product
export const SET_GOODS_UNIT = 'SET_GOODS_UNIT';
export const SET_GOODS_LIST = 'SET_GOODS_LIST';
export const RESET_GOODS_LIST = 'RESET_GOODS_LIST';

// SETTING
export const SET_SETTING_BANNER = 'SET_SETTING_BANNER';
export const SET_SETTING_NOTICE = 'SET_SETTING_NOTICE';
export const SET_SETTING_PROMOTION = 'SET_SETTING_PROMOTION';

// user
export const SET_FAVORITE_LIST = 'SET_FAVORITE_LIST';
export const RESET_FAVORITE_LIST = 'RESET_FAVORITE_LIST';
export const SET_ORDER_LIST = 'SET_ORDER_LIST';
export const RESET_ORDER_LIST = 'RESET_ORDER_LIST';
export const SET_ADDRESS_LIST = 'SET_ADDRESS_LIST';
export const RESET_ADDRESS_LIST = 'RESET_ADDRESS_LIST';

// information
export const SET_INFO_LIST = 'SET_INFO_LIST';

// cart
export const SET_CART_LIST = 'SET_CART_LIST';
export const RESET_CART_LIST = 'RESET_CART_LIST';
